<template>
    <div class="tableIngresos">
        <vs-row>
            <vs-col w="12">
                <vs-input v-if="users != ''" class="ml-auto searchWidth" v-model="search" placeholder="Buscar">
                    <template #icon>
                        <i class="fas fa-search"></i>
                    </template>
                </vs-input>
                <vs-button
                    v-if="users != ''"
                    success
                    relief
                    :active="active == 5" 
                    :loading="loadingExcel"
                    @click="active = 5, getInfoNoPagados()"
                    class="ml-auto"
                >
                    <i class="fas fa-download mr-2"></i> Descargar reporte
                </vs-button>
                <vs-button
                    v-if="users != ''"
                    primary
                    relief
                    :active="active == 5" 
                    :loading="loadingExcel"
                    @click="getGenerarCargos()"
                    class="ml-auto"
                >
                    <i class="fas fa-check mr-2"></i> Generar Cargos
                </vs-button>
                <div style="max-width: 100%;">
                    <h5 v-if="infoCard.alumnosTotal">Número total de alumnos: <strong>{{ infoCard.alumnosTotal}}</strong></h5>
                    <vs-table striped clas="table-responsive" 
                        v-dragscroll="{ target: '.vs-table', active: true }">
                        <template #thead>
                        <vs-tr>
                            <vs-th style="width: 50px !important; ">
                                <vs-checkbox
                                    :indeterminate="selected.length == users.length" v-model="allCheck"
                                    @change="selected = $vs.checkAll(selected, users)"
                                />
                            </vs-th>
                            <vs-th sort @click="users = $vs.sortData($event ,users, 'nombre')">
                                Alumno
                            </vs-th>
                            <vs-th sort @click="users = $vs.sortData($event ,users, 'programa')">
                                Programa
                            </vs-th>
                            <vs-th>
                                Ciclo Escolar
                            </vs-th>
                            <vs-th>
                            </vs-th>
                        </vs-tr>
                        </template>
                        <template #tbody style="vertical-align: top">
                        <vs-tr
                            :key="i"
                            v-for="(tr, i) in $vs.getSearch(users, search)"
                            :data="tr"
                            style="vertical-align: top"
                        >
                            <vs-td checkbox>
                                <vs-checkbox :val="tr" v-model="selected" />
                            </vs-td>
                            <vs-td>
                                <md-content class="cienCincuenta d-flex">
                                    <div>
                                        <vs-avatar circle>
                                            <img :src="'/api/personas/' + tr.persona_id + '/avatar'" @error="setAltImg" alt="">
                                        </vs-avatar>
                                    </div>
                                    <div class="ml-2" style="dipplay: inline-grid">
                                        <strong>{{ tr.nombre }}</strong>
                                        <span style="text-transform: uppercase; font-size: 11px;">Matrícula</span>
                                        <strong>{{ tr.matricula }}</strong>
                                    </div>
                                </md-content>
                            </vs-td>
                            <vs-td>
                                <md-content class="cien">
                                    <p>{{ tr.programa }}</p>
                                </md-content>
                            </vs-td>
                            <vs-td>
                                <md-content class="cien">
                                    <p>{{tr.cicloEscolar}}</p>
                                </md-content>
                            </vs-td>
                            <vs-td>
                                <md-content class="cienCincuenta">
                                        <vs-button
                                            success
                                            flat
                                            :href="'/estado-de-cuenta/' + window.atob(tr.estadoCuenta) + '/gestion?institucion_id=' + institucion + '&ciclo_escolar_id=' + cicloEscolar"
                                            blank
                                        >
                                            Gestion de finanzas
                                        </vs-button>
                                </md-content>
                            </vs-td>
                        </vs-tr>
                        </template>
                        <template #notFound>
                            No hay información
                        </template>
                    </vs-table>
                </div>
    
            </vs-col>
        </vs-row>

    </div>
</template>

<script>
import axios from 'axios'
import { dragscroll } from 'vue-dragscroll'
import reportes from '../../../../api/requests/reportes.js'
export default {
    props:[
        'users',
        'cicloEscolar',
        'institucion',
        'ciclosEscolares',
        'instituciones',
        'filtros',
        'infoCard',
        'grupo'
    ],
    data(){
        return{
            search: '',
            active: 0,
            selected: [],
            allCheck: false,
            statusColores: {
                "Facturado" : "green",
                "No facturado": "red"
            },
            colorFactura: {
                "Efectivo": "green",
                "Cheque nominativo": "yellow",
                "Transferencia electrónica de fondos": "blue",
                "Tarjeta de crédito" : "red",
                "Monedero electrónico": 'purple',
                "Dinero electrónico": "gray",
                "Vales de despensa": "pink",
                "Dación en pago": "brown",
                "Pago por subrogación": "green",
                "Pago por consignación": "yellow",
                "Condonación" : "blue",
                "Compensación" : "red",
                "Novación": 'purple',
                "Confusión": "gray",
                "Remisión de deuda": "pink",
                "Prescripción o caducidad": "brown",
                "A satisfacción del acreedor": "green",
                "Tarjeta de débito": "yellow",
                "Tarjeta de servicios" : "blue",
                "Aplicación de anticipos" : "red",
                "Intermediario Pagos": 'purple',
                "Por definir": "gray"
            },
            loadingExcel: false
        }
    },
    directives: {
       'dragscroll': dragscroll
    },
    methods: {
        
        async getInfoNoPagados() {
            const loading = this.$vs.loading()
            try {
                
                let params = {
                    "institucion": this.institucion,
                    "cicloEscolar": this.cicloEscolar,
                    "type_response": "file",
                    "grupo": this.grupo,
                    "report": "sinCargos"
                }
                const response = await reportes.getInfoPendientes(params)
                loading.close()
                if(response){
                    window.location.href = response.request.responseURL;
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'success',
                        position: 'bottom-right',
                        title: 'Éxito',
                        text: 'Descarga lista'
                    })
                }
            }
            catch{
                loading.close()
                this.$vs.notification({
                    progress: 'auto',
                    color: 'success',
                    position: 'bottom-right',
                    title: 'Hubo un error inesperado'
                })
            }
        },
        async getGenerarCargos (type) {
            const loading = this.$vs.loading()
            let datos = []
            for(var x = 0;x < this.selected.length; x++){
                var obj = {}
                obj = {
                    id : atob(this.selected[x].estadoCuenta),
                    ciclo_escolar: this.cicloEscolar,
                    institucion: this.institucion,
                    programa: this.selected[x].programa_id
                }
                datos.push(obj)
            }
            let alumnos = datos
            if(alumnos.length == 0){
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'danger',
                        position: 'bottom-right',
                        title: 'es necesario llenar los registro para generar los cargos',
                    })
                loading.close()
            }else{
                const vm = this
                try {
                    const response = await reportes.getGenerarCargos(alumnos)
                    if(response){
                        this.$vs.notification({
                            progress: 'auto',
                            color: 'success',
                            position: 'bottom-right',
                            title: 'Operación éxitosa'+" "+response.data.message,
                        })
                        this.selected = []
                        this.$emit('refreshTable')
                        loading.close()
                    }
                    

                } catch (error) {
                    console.log(error)
                    loading.close()
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'danger',
                        position: 'bottom-right',
                        title: 'Favor de contactar al administrador',
                    })
                }
            }
        },
        getFacturado(value){
             if (value.facturado){
                return 'Facturado'
            }else{
                return 'No facturado'
            }
        },
        getColor(status){
            if (status === 'Facturado'){
                return `col-${this.statusColores[status]}`
            }else {
                return `col-${this.statusColores[status]}`
            }
        },
        getColorMetodo(status){
            if (status.metodoPago === 'Efectivo'){
                return `col-${this.colorFactura[status.metodoPago]}`
            }else if (status.metodoPago === 'Cheque nominativo'){
                return `col-${this.colorFactura[status.metodoPago]}`
            }else if (status.metodoPago === 'Transferencia electrónica de fondos'){
                return `col-${this.colorFactura[status.metodoPago]}`
            }else if (status.metodoPago === 'Tarjeta de crédito'){
                return `col-${this.colorFactura[status.metodoPago]}`
            }else if (status.metodoPago === 'Monedero electrónico'){
                return `col-${this.colorFactura[status.metodoPago]}`
            }else if (status.metodoPago === 'Dinero electrónico'){
                return `col-${this.colorFactura[status.metodoPago]}`
            }else if (status.metodoPago === 'Vales de despensa'){
                return `col-${this.colorFactura[status.metodoPago]}`
            }else if (status.metodoPago === 'Dación en pago'){
                return `col-${this.colorFactura[status.metodoPago]}`
            }else if (status.metodoPago === 'Pago por subrogación'){
                return `col-${this.colorFactura[status.metodoPago]}`
            }else if (status.metodoPago === 'Pago por consignación'){
                return `col-${this.colorFactura[status.metodoPago]}`
            }else if (status.metodoPago === 'Condonación'){
                return `col-${this.colorFactura[status.metodoPago]}`
            }else if (status.metodoPago === 'Compensación'){
                return `col-${this.colorFactura[status.metodoPago]}`
            }else if (status.metodoPago === 'Confusión'){
                return `col-${this.colorFactura[status.metodoPago]}`
            }else if (status.metodoPago === 'Novación'){
                return `col-${this.colorFactura[status.metodoPago]}`
            }else if (status.metodoPago === 'Remisión de deuda'){
                return `col-${this.colorFactura[status.metodoPago]}`
            }else if (status.metodoPago === 'Prescripción o caducidad'){
                return `col-${this.colorFactura[status.metodoPago]}`
            }else if (status.metodoPago === 'A satisfacción del acreedor'){
                return `col-${this.colorFactura[status.metodoPago]}`
            }else if (status.metodoPago === 'Tarjeta de débito'){
                return `col-${this.colorFactura[status.metodoPago]}`
            }else if (status.metodoPago === 'Tarjeta de servicios'){
                return `col-${this.colorFactura[status.metodoPago]}`
            }else if (status.metodoPago === 'Aplicación de anticipos'){
                return `col-${this.colorFactura[status.metodoPago]}`
            }else if (status.metodoPago === 'Intermediario Pagos'){
                return `col-${this.colorFactura[status.metodoPago]}`
            }else if (status.metodoPago === 'Por definir'){
                return `col-${this.colorFactura[status.metodoPago]}`
            }
        },
        setAltImg(event) {
            event.target.src = "https://sigem.maristas.mx/img/default-avatar.jpg"
        },
    },
}
</script>

<style lang="scss" scoped>
    .cardReportes{
        width: 100%;
        background-color:white;
        justify-content: space-between;
        @media only screen and (max-width: 768px) {
            margin: 16px;
        }
        @media only screen and (min-width: 768px) {
            margin: 16px 30px;
        }
        border-radius: 3px;
        padding: 10px
    }
    .searchWidth{
        @media only screen and (max-width: 768px) {
            width: 100%;
        }
        @media only screen and (min-width: 768px) {
            width: 30%;
        }
    }
    .cien {
        width: 100px;
        background: none;
        display: inline-flex;
        justify-content: center;
        align-items: center;
    }
    .cienCincuenta {
        width: 150px;
        background: none;
        display: inline-flex;
        justify-content: center;
        align-items: center;
    }
    .trecientos{
        width: 300px;
        background: none;
        display: inline-flex;
        justify-content: center;
        align-items: center;

    }

    .mdChip{
        background: rgba($color: #000000, $alpha: 0.5);
        margin:1.7% 0;
        padding: 2% 6%;
        text-align: center;
        border-radius: 15px;
        font-size: 11px;
    }
    .tableIngresos .vs-table__th__content{
        justify-content: center;
    }

</style>
<style scoped>
    /* .vs-table-content {
        overflow-x: auto !important;
    } */
    .vs-table{
        overflow-x: none;
    }

    .vs-table__tbody{
        vertical-align: top !important;
    }

    .col-yellow{
        background: rgb(255, 248, 236);
        color: #febf3d;
    }

    .col-red{
        color: #f62d51;
        background: rgb(249, 231, 235);
    }

    .col-green{
        color: #55ce63;
        background: rgb(232, 253, 235);
    }

    .col-purple{
        color: purple;
        background: rgb(232, 218, 239);
    }

    .col-blue{
        color: #2874A6;
        background: rgb(214, 234, 248);
    }

    .col-gray{
        color: #5F6A6A;
        background: rgb(242, 243, 244);
    }

    .col-pink{
        color: #F08080;
        background: rgb(255, 236, 236);
    }

    .col-brown{
        color: #784212;
        background: rgb(250, 229, 211);
    }
    .vs-avatar img{
        object-fit:contain;
    }

</style>

<style>
    .tableIngresos .vs-table__th__content{
        justify-content: center;
    }

</style>